import { brandedUuid } from '@multiplier/lib-shared-flavor';
export const OrganizationIdSchema = brandedUuid('Invalid organization ID format');
//# sourceMappingURL=OrganizationSchemas.js.map